import { createContext } from 'react'

export const UploadContext = createContext(null)
